import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Dialog from './Dialog';
import TextInput from '../forms/TextInput';
import TextArea from '../forms/TextArea';
import ImagePicker from '../pickers/ImagePicker/ImagePicker';
import em from '../raketa-ui/em';

class PageSettingsDialog extends React.Component {
  constructor(props) {
    super(props);

    console.log(props.page)

    this.state = {
      title: props.page ? props.page.title : '',
      description: props.page ? props.page.description : '',
      image: props.page ? props.page.image : {},
    }
  }

  render() {
    const {
      open,
      page,
      onClose,
      onSave,
    } = this.props;
    const { title, description, image } = this.state;

    return (
      <Dialog
        open={open}
        onClose={onClose}
        title="Content Optimization"
        primaryLabel="Save"
        onPrimary={() => onSave({ title, description, image })}
        secondaryLabel="Close"
      >
        <TextInput
          label="Meta Title"
          value={title}
          onChange={title => this.setState({ title })}
        />
        <TextArea
          label="Meta Description"
          value={description}
          onChange={description => this.setState({ description })}
        />
        <ImagePicker
          label="OpenGraph Image"
          value={image}
          onChange={image => this.setState({ image })}
        />
      </Dialog>
    );
  }
}

PageSettingsDialog.defaultProps = {
  page: {},
};

PageSettingsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  page: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default PageSettingsDialog;
